import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import {
  AiFilterInput,
  AiFilterFragmentFragment,
} from '@/__generated__/graphql';
import { gql } from '@/__generated__/index';
import { MutationUpdateAiFilterArgs } from '@/__generated__/schema-types';
import { AIFilterFragment } from '@/routes/_app.p.news-deck/fragments';

const UPDATE_AI_FILTER = gql(`
  mutation UpdateAIFilter($id: ID!, $input: AIFilterInput!) {
    updateAIFilter(id: $id, input: $input) {
      ...AIFilterFragment
    }
  }
`);

export const useEditAiFilter = () => {
  const toast = useToast();
  const [updateAiFilter, { loading }] = useMutation<
    { updateAIFilter: AiFilterFragmentFragment },
    MutationUpdateAiFilterArgs
  >(UPDATE_AI_FILTER, {
    onCompleted(data) {
      toast.success({
        title: 'AI filter updated',
        subTitle: data.updateAIFilter.name,
      });
    },
    onError(error) {
      toast.error({
        title: 'Error updating AI filter',
        subTitle: error?.message || 'Please try again',
      });
    },
    update(cache, { data }) {
      const updatedFilter = data?.updateAIFilter;
      if (updatedFilter) {
        cache.modify({
          fields: {
            aiFilters(filters) {
              const updatedFilterRef = cache.writeFragment({
                fragment: AIFilterFragment,
                fragmentName: 'AIFilterFragment',
                data: updatedFilter,
              });

              if (updatedFilterRef) {
                return filters.map((item: { __ref: string }) =>
                  item.__ref === updatedFilterRef.__ref
                    ? updatedFilterRef
                    : item,
                );
              }
              return filters;
            },
          },
        });
      }
    },
  });

  const editFilter = (id: string, input: AiFilterInput) => {
    return updateAiFilter({
      variables: {
        id,
        input,
      },
    });
  };

  return { editFilter, loading };
};
